/**
 * How a title picker matches typed text: by display name only, case-insensitive
 * substring. cmdk's default filter also scores an item's `value` and every
 * keyword together, and the picker rows carry an id as `value`, so a fragment
 * of an id would otherwise match. Shared by the /rds roster title and the
 * Appointment Home title so the two pickers cannot drift.
 */
export function matchesNameSearch(
  search: string,
  names: readonly string[] | undefined,
): number {
  const needle = search.trim().toLowerCase();
  if (needle === "") return 1;
  const matches = (names ?? []).some((name) => name.toLowerCase().includes(needle));
  return matches ? 1 : 0;
}
